import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';

import TextSearchInput from 'components/common/TextSearchInput/textSearchInput';

import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/Details.module.scss';

export const Min = () => {
    const { setValue, control, watch } = useFormContext<Risk>();

    return (
        <div>
            <div className={classes.title}>Min ({watch('impactType') === 'RELATIVE' ? '%' : 'days'})</div>
            <Controller
                render={({ field }) => (
                    <TextSearchInput
                        {...field}
                        placeholder="Enter minimum value"
                        isSearch={false}
                        className={classes.durationInput}
                        value={field.value?.toString() || ''}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value === '' || value === '-') {
                                field.onChange(value === '' ? 0 : value);
                            } else {
                                const numValue = Number(value);
                                if (!isNaN(numValue)) {
                                    field.onChange(numValue);
                                }
                            }
                        }}
                        handleClear={() => setValue('distributionRange.min', 0)}
                    />
                )}
                name="distributionRange.min"
                control={control}
                rules={{
                    required: 'Minimum value is required',
                    validate: {
                        notBothZero: (value) => {
                            const maxValue = watch('distributionRange.max');
                            return !(value === 0 && maxValue === 0) || 'Min and max cannot both be 0';
                        },
                        maxGreaterThanMin: (value) => {
                            const maxValue = watch('distributionRange.max');
                            return maxValue > value || 'Max must be greater than min';
                        },
                        allowNegativeOnlyForAbsolute: (value) => {
                            const impactType = watch('impactType');
                            if (impactType === 'RELATIVE' && value < 0) {
                                return 'Negative values are only allowed for Absolute impact type';
                            }
                            return true;
                        },
                    },
                }}
            />
        </div>
    );
};
